import React from 'react';

export default function LegacyPrivacy20250918() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-semibold mb-6">
          Ask Arthur Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Effective: July 1, 2025 — Last Updated: September 18, 2025
        </p>

        <div className="prose prose-gray max-w-none space-y-4">
          <h2>1. Information We Collect</h2>
          <p>
            We collect your mobile phone number, name (if provided), date and
            time of opt‑in, IP address, device and browser information, and
            message interaction data. If you interact with restaurants through
            our platform, we may collect order and reservation details and
            preferences you share.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>
            We use your information to deliver transactional messages (order
            confirmations, status updates, reservation updates), provide
            customer support, improve our services, and comply with legal
            obligations. We only send SMS if you have explicitly opted in.
          </p>

          <h2>3. Information Sharing</h2>
          <p>
            We never sell or rent your personal data. We share data only with
            restaurant partners you interact with, trusted service providers
            under strict confidentiality, or when required by law. We do not
            sell or share mobile data for marketing or promotional purposes.
          </p>

          <h2>4. Data Storage &amp; Security</h2>
          <p>
            Your data is stored securely with appropriate technical and
            organizational measures. Data may be processed in the United States
            or other locations where we or our providers operate, and is
            retained only as necessary or required by law.
          </p>

          <h2>5. International Users</h2>
          <p>
            We comply with TCPA (US), CASL (Canada), and GDPR (EU). EU users may
            request access, correction, deletion, or restriction of processing,
            and may object to processing. Contact privacy@AskArthur to exercise
            these rights.
          </p>

          <h2>6. Opting Out</h2>
          <p>
            You can opt out at any time by replying STOP to any message, reply
            HELP for assistance, or email support@AskArthur.
          </p>

          <h2>7. Changes to This Policy</h2>
          <p>
            We may update this policy periodically. Material changes will be
            reflected in the “Last Updated” date and, when appropriate,
            communicated directly.
          </p>
        </div>
      </div>

      <footer className="py-10 text-center text-gray-500 text-sm">
        <div>2025 Ronin Tech LLC DBA ©Ask Arthur. All rights reserved.</div>
        <div>100 Norfolk St</div>
        <div>New York, NY 10002</div>
      </footer>
    </div>
  );
}
